import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';

const Button = VideoJS.getComponent('Button');

class ASMutedOverlayButton extends Button {
    constructor(player, options) {
        super(player, options);

        this.one('tap', this.handleClick);
        this.on(player, 'volumechange', this.handleVolumeChange);
    }

    buildCSSClass() {
        return 'as-muted-overlay-button';
    }

    handleClick() {
        this.player_.muted(false);
        this.removeMe();
    }

    handleVolumeChange() {
        const vol = this.player_.volume();

        if (vol > 0 || !this.player_.muted()) {
            this.removeMe();
        }
    }

    removeMe() {
        this.player_.removeChild(this);
        this.dispose();
    }
}

ASMutedOverlayButton.prototype.controlText_ = 'Unmute';

VideoJS.registerComponent(Controls.MUTED_OVERLAY_BUTTON, ASMutedOverlayButton);

export default ASMutedOverlayButton;



// WEBPACK FOOTER //
// ./src/player/components/ASMutedOverlayButton.js